import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[App LifeCycle]";
export const APP_LIFE_CYCLE_ACTION_TYPE = {
	initSuccess: `${ACTION_PREFIX} Init Success ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class AppLifeCycleAction {
	initSuccess(): Action {
		return {
			type: APP_LIFE_CYCLE_ACTION_TYPE.initSuccess,
		};
	}
}
